<template>
  <v-dialog v-model="dialogActive" width="600">
    <template v-slot:activator="{ on: dialogOn }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltipOn }">
          <v-list-item-content v-on="{ ...dialogOn, ...tooltipOn }" style="cursor:pointer">
            <v-list-item-title>{{ name || 'Popup Set: ' + id }}</v-list-item-title>
            <v-list-item-subtitle>{{ subText }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <span>Click to view details about their interaction with this popup set</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>{{ name || 'Popup Set: ' + id }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="dialogActive = false" icon>
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-list>
        <v-list-item v-for="({ title, status, date }, index) in popupItems" :key="index">
          <v-list-item-avatar v-if="activatable">
            <v-icon v-if="status === 'Y'" color="success">fas fa-check-circle</v-icon>
            <v-icon v-else-if="status === 'N'" color="error">fas fa-times-circle</v-icon>
            <v-icon v-else color="info">fas fa-question-circle</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ title }}</v-list-item-title>
            <v-list-item-subtitle v-if="status === 'Y'">Selected: {{ stringFormatDate(date) }}</v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="status === 'N'">Declined: {{ stringFormatDate(date) }}</v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="activatable && date">Viewed (no option chosen): {{ stringFormatDate(date) }}</v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="date">Viewed: {{ stringFormatDate(date) }}</v-list-item-subtitle>
            <v-list-item-subtitle v-else>Not Viewed</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-card-actions>
        <v-btn @click="dialogActive = false" text>Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { stringFormatDate } from '../../../helpers/formatters'
import { ref } from '@vue/composition-api'
export default {
  props: {
    name: String,
    id: String,
    items: Array
  },
  setup (props, { root }) {
    const dialogActive = ref(false)
    const popupItems = ref([])
    const subText = ref('')
    const activatable = ref(false)

    root.$feathers.service('orientation/block').get(props.id).then((data) => {
      activatable.value = data.activatable
      for (let i = 0; i < data.items.length; i++) {
        let obj = { title: data.items[i].title }
        if (i in props.items) {
          if (data.activatable && 'date' in props.items[i] && props.items[i].date != null && props.items[i].status === 'Y') {
            if (subText.value !== '') subText.value += ', ' + data.items[i].title
            else subText.value = 'Selected: ' + data.items[i].title
          }
          obj = { ...obj, ...props.items[i] }
        }
        popupItems.value.push(obj)
      }
    })

    return {
      dialogActive,
      popupItems,
      subText,
      activatable,
      stringFormatDate
    }
  }
}
</script>
